<template>
    <v-container grid-list-md fluid fill-height>
        <v-layout row wrap style="width: 100%;">
            <v-flex >
                <v-card>
                    <statistics-professor-marks :key="$route.fullPath"/>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>
<script>
    import StatisticsProfessorMarks
        from "@/components/admin/StatisticsMarks/StatisticsProfessorMarks.vue";

    export default  {
        components: {
            StatisticsProfessorMarks,
        },
        data: () => {
            return {
             

            };
        },
    }
</script>